import { render, staticRenderFns } from "./OnlineUsers.vue?vue&type=template&id=070bd4f7&scoped=true&"
import script from "./OnlineUsers.vue?vue&type=script&lang=ts&"
export * from "./OnlineUsers.vue?vue&type=script&lang=ts&"
import style0 from "./OnlineUsers.vue?vue&type=style&index=0&id=070bd4f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bd4f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VMenu})
